import { Box, Checkbox, CheckboxGroup, Divider, Stack, Text } from '@chakra-ui/react';

import { titleCase } from 'utils';

export const MultiSelectFilter = ({
    options,
    filterValue,
    setFilterValue,
    allowClear,
}: {
    options: string[];
    filterValue: string[] | undefined;
    setFilterValue: (value?: string[]) => void;
    allowClear?: boolean;
}) => {
    return (
        <Stack gap={0}>
            {allowClear && (
                <>
                    <Box textAlign="right">
                        <Text
                            textTransform="none"
                            fontWeight="normal"
                            letterSpacing="initial"
                            color="teal.200"
                            fontSize="small"
                            _hover={{
                                cursor: 'pointer',
                            }}
                            onClick={() => setFilterValue(undefined)}
                        >
                            Clear
                        </Text>
                    </Box>
                    <Divider mt={3} mb={2} />
                </>
            )}
            <CheckboxGroup
                colorScheme="teal"
                value={filterValue}
                onChange={(value) => setFilterValue(value as string[])}
            >
                {options.map((option) => (
                    <Checkbox key={option} value={option} p={1} _hover={{ background: 'whiteAlpha.100' }}>
                        <Text textTransform="none" fontWeight="normal" letterSpacing="initial">
                            {titleCase(option)}
                        </Text>
                    </Checkbox>
                ))}
            </CheckboxGroup>
        </Stack>
    );
};
